import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { setDate, setHasTips, setHasWords, setSites, setTags, setTypes } from "../../../store/filters/filters.slice";
import { Filters } from "../../interfaces/Filters";
import FilterChip from "../filter-chip/FilterChip";
import { FiltersChipsNames } from "../../enums/FiltersChipsNames";
import StringHelper from '../../helpers/string.helper';

const FiltersChips = ({ filters }: { filters: Filters }) => {
  const dispatch = useDispatch();
  const deleteHandler = useCallback((filterID: number, entity: FiltersChipsNames) => {
    switch (entity) {
      case FiltersChipsNames.TYPE:
        dispatch(setTypes(filters.types.filter((type) => type.id !== filterID)));
        break;
      case FiltersChipsNames.SITE:
        dispatch(setSites(filters.sites.filter((site) => site.id !== filterID)));
        break;
      case FiltersChipsNames.TAG:
        dispatch(setTags(filters.tags.filter((tag) => tag.id !== filterID)));
        break;
      case FiltersChipsNames.TIP:
        dispatch(setHasTips(null));
        break;
      case FiltersChipsNames.KEYWORD:
        dispatch(setHasWords(null));
        break;
      case FiltersChipsNames.DATE:
        dispatch(setDate(null));
        break;
      default:
        break;
    }
  }, [dispatch, filters]);

  return <Swiper
    spaceBetween={5}
    slidesPerView={'auto'}
    modules={[Navigation]}
    navigation >
    {filters.hasWords && (
      <SwiperSlide key="keywords-chip">
        <FilterChip
          id={Number(StringHelper.generateRandomString(8))}
          name={filters.hasWords}
          onDelete={deleteHandler}
          entity={FiltersChipsNames.KEYWORD}
        />
      </SwiperSlide>
    )}
    {filters.types.map((type) => <SwiperSlide key={type.id}><FilterChip id={type.id} name={type.name} onDelete={deleteHandler} entity={FiltersChipsNames.TYPE} /> </SwiperSlide>)}
    {null !== filters.hasTips ?
      (
        <SwiperSlide key={StringHelper.generateRandomString(10)} >
          <FilterChip
            id={Number(StringHelper.generateRandomString(2))}
            name={filters.hasTips ? 'With Tips' : 'Without Tips'}
            onDelete={deleteHandler}
            entity={FiltersChipsNames.TIP} />
        </SwiperSlide>
      ) : null}
    {filters.sites.map((site) => <SwiperSlide key={site.id}><FilterChip id={site.id} name={site.name} onDelete={deleteHandler} entity={FiltersChipsNames.SITE} /> </SwiperSlide>)}
    {filters.tags.map((tag) => <SwiperSlide key={tag.id} ><FilterChip id={tag.id} name={tag.attributes.name} onDelete={deleteHandler} entity={FiltersChipsNames.TAG} /> </SwiperSlide>)}
    {filters.date ? <SwiperSlide ><FilterChip id={Number(StringHelper.generateRandomString(8))} name={filters.date.name} onDelete={deleteHandler} entity={FiltersChipsNames.DATE} /> </SwiperSlide> : null}
  </Swiper>
};

export default FiltersChips;
